import React from 'react';

const LineChart = ({ data = [] }) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const chartData = data.length === 12 ? data : Array(12).fill(0);
  const maxValue = Math.max(...chartData, 1);

  return (
    <>
      <style>{`
.chart-container { width: 100%; height: 300px; position: relative; }
.chart-svg { width: 100%; height: 100%; }
.chart-line { fill: none; stroke: #3B82F6; stroke-width: 3; }
.chart-area { fill: url(#gradient); opacity: 0.2; }
.chart-point { fill: #3B82F6; stroke: #FFF; stroke-width: 2; }
.chart-grid { stroke: #E2E8F0; stroke-width: 1; }
.chart-label { font-size: 12px; fill: #64748B; font-weight: 600; }
      `}</style>
      <div className="chart-container">
        <svg className="chart-svg" viewBox="0 0 1200 300">
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#3B82F6" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#3B82F6" stopOpacity="0" />
            </linearGradient>
          </defs>
          
          {/* Grid lines */}
          {[0, 1, 2, 3, 4].map(i => (
            <line 
              key={i} 
              x1="50" 
              y1={50 + i * 50} 
              x2="1150" 
              y2={50 + i * 50} 
              className="chart-grid" 
            />
          ))}

          {/* Line path */}
          <path
            className="chart-line"
            d={chartData.map((val, idx) => {
              const x = 50 + (idx * 100);
              const y = 250 - (val / maxValue * 200);
              return `${idx === 0 ? 'M' : 'L'} ${x} ${y}`;
            }).join(' ')}
          />

          {/* Area fill */}
          <path
            className="chart-area"
            d={`
              ${chartData.map((val, idx) => {
                const x = 50 + (idx * 100);
                const y = 250 - (val / maxValue * 200);
                return `${idx === 0 ? 'M' : 'L'} ${x} ${y}`;
              }).join(' ')}
              L 1150 250 L 50 250 Z
            `}
          />

          {/* Points */}
          {chartData.map((val, idx) => {
            const x = 50 + (idx * 100);
            const y = 250 - (val / maxValue * 200);
            return <circle key={idx} cx={x} cy={y} r="5" className="chart-point" />;
          })}

          {/* Labels */}
          {months.map((month, idx) => (
            <text 
              key={idx} 
              x={50 + (idx * 100)} 
              y="280" 
              textAnchor="middle" 
              className="chart-label"
            >
              {month}
            </text>
          ))}
        </svg>
      </div>
    </>
  );
};

export default LineChart;